import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { listPastParties } from '../api/client.js';
import { PAST_PARTIES_QUERY_KEY } from '../api/queryKeys.js';

import type { PastPartiesResponse } from '@mixwire/contracts';

export const usePastParties = (): UseQueryResult<PastPartiesResponse> =>
  useQuery({
    queryKey: PAST_PARTIES_QUERY_KEY,
    queryFn: listPastParties,
    staleTime: 60_000,
  });
